import React from 'react';
import { TableItemActionsNew, Icons, PriceLabel } from 'components';

const columns = (navigate, sendSms, handleClick, actionsList , currencyText) => {
  return [
    {
      title: 'شناسه فاکتور',
      field: 'invoiceId', // 1349
      align: 'center',
      filtering: false,
      sorting: false,
      cellStyle: {
        width: '1%',
      },
      headerStyle: {
        width: '1%',
      },
    },
    {
      title: 'تاریخ صدور',
      dir: 'ltr',
      render: (rowData) => (
        <div>
          <bdi style={{ direction: 'ltr' }}>
            {rowData.issueDate} {rowData.issueTime}
          </bdi>
        </div>
      ),
    },
    {
      title: `مبلغ کل (${currencyText})`,
      align: 'center',
      render: (rowData) => (
        <PriceLabel amount={rowData.totalAmount} />
      ),
    },
    {
      title: `قابل پرداخت (${currencyText})`,
      align: 'center',
      render: (rowData) => (
        <PriceLabel amount={rowData.amountPayable} />
      ),
    },
    {
      title: 'تاریخ پرداخت',
      align: 'center',
      dir: 'ltr',
      render: (rowData) => (
        <div>
          <bdi style={{ direction: 'ltr' }}>
            {rowData.dateOfPayment || rowData.timeOfPayment ? `${rowData.dateOfPayment + ' ' + rowData.timeOfPayment}` : '_'}
          </bdi>
        </div>
      ),
    },
    {
      title: 'وضعیت فاکتور',
      field: 'invoiceStatus', // 1352
      align: 'center',
    },
    {
      title: 'حساب تفصیلی',
      field: 'guildId',
      align: 'center',
      render: (rowData) => rowData?.guildName ?? '-',
    },
    {
      title: ' ',
      align: 'left',
      render: (rowData) => {
        return (
          <div style={{ display: 'block', fontSize: 12, lineHeight: '30px' }}>
            <div>
            کاهش‌یافته : {rowData.decreased === '0' ? 'خیر' : <Icons icon="CaretDown" color="#f44336" size="20" />}
            </div>
            <div>روش‌پرداخت : {rowData.paymentMethod || '-'}</div>
            <div>
              شماره کارت : <span dir={'ltr'}>{rowData.cardNumber || '-'}</span>
            </div>
          </div>
        );
      },
    },
    ...(actionsList['followersListFinancialPaymentBtn'] ||
      actionsList['invoiceGuildPaymentBtn'] ||
      actionsList['invoiceGuildOperationBtn'] ||
      actionsList['paymentInvoicListFinancialBtn'] ||
      actionsList['detailInvoicListFinancialBtn'] ||
      actionsList['followersListFinancialOperationBtn'] ||
      actionsList['operationInvoicListFinancialBtn'] ? [{
        title: 'عملیات',
        field: 'operationSmall',
        filtering: false,
        sorting: false,
        align: 'right',
        cellStyle: {
          width: '1%',
        },
        headerStyle: {
          width: '1%',
        },
        render: (rd) => (
          <TableItemActionsNew
            iconButton
            startIcon={<Icons icon="MoreHorizontal" color="#667585" size="20" />}
            title=""
            otherMenus={[
              {
                title: 'عملیات فاکتور',
                isShow: !!(actionsList['detailInvoicListFinancialBtn'] ||
                  actionsList['followersListFinancialOperationBtn'] ||
                  actionsList['operationInvoicListFinancialBtn'] ||
                  actionsList['invoiceGuildOperationBtn']),
                isOpen: false,
                id: 'FinancialOperation',
                children: [
                  {
                    title: 'جزییات',
                    isShow: true,
                    onClick: () => navigate(`/Invoice/${rd.invoiceId}/invoice-details`),
                  },
                  {
                    title: 'بستن فاکتور',
                    isShow: true,
                    disabled: rd.invoiceStatus !== 'پرداخت شده',
                    otherLocation: false,
                    onClick: () => {
                      handleClick(rd, ActionTypes.CLOSE);
                    },
                  },
                  {
                    title: 'کاهش فاکتور',
                    isShow: true,
                    disabled: rd.invoiceStatus !== 'پرداخت شده',
                    onClick: () => {
                      if (rd.invoiceStatus === 'پرداخت شده')
                        navigate(`/Invoice/${rd.invoiceId}/invoice-reduce`);
                    },
                  },
                  {
                    title: 'کنسل فاکتور',
                    isShow: true,
                    disabled: !['پرداخت نشده', 'پرداخت شده'].includes(rd.invoiceStatus),
                    otherLocation: false,
                    onClick: () => {
                      handleClick(rd, ActionTypes.CANCEL);
                    },
                  },
                  {
                    title: 'پرداخت فاکتور(خارج از پلتفرم)',
                    isShow: true,
                    disabled: rd.invoiceStatus !== 'پرداخت نشده',
                    otherLocation: false,
                    onClick: () => {
                      if (!(rd.invoiceStatus !== 'پرداخت نشده')) {
                        handleClick(rd, ActionTypes.PAYMENT_OUT_OF_PLATFORM);
                      }
                    },
                  },
                ],
              },
              {
                title: 'عملیات پرداخت',
                isShow: !!(actionsList['followersListFinancialPaymentBtn'] ||
                  actionsList['paymentInvoicListFinancialBtn'] ||
                  actionsList['invoiceGuildPaymentBtn']),
                isOpen: false,
                id: 'operatin',
                children: [
                  {
                    title: 'ارسال پیامک پرداخت',
                    isShow: true,
                    disabled: rd.invoiceStatus !== 'پرداخت نشده',
                    otherLocation: false,
                    onClick: () => {
                      if (rd.invoiceStatus !== 'پرداخت نشده') {
                        // do nothing
                      } else {
                        sendSms(rd);
                      }
                    },
                  },
                  {
                    title: 'لینک پرداخت',
                    isShow: true,
                    disabled: rd.invoiceStatus !== 'پرداخت نشده',
                    otherLocation: false,
                    onClick: () => {
                      if (!(rd.invoiceStatus !== 'پرداخت نشده')) {
                        handleClick(rd, ActionTypes.SHARE_PAYMENT_LINK);
                      }
                    },
                  },

                  {
                    title: 'پروفایل پرداخت',
                    isShow: true,
                    otherLocation: false,
                    onClick: () => {
                      navigate(`/ProfileDetailInvoice?InvoiceId=${rd.invoiceId}`);

                    },
                  },
                ],
              },
            ]
            }
          />
        ),
      }] : []),
  ];
}

const columnsId = {
  invoiceId: '1349',
  tax: '1444',
  invoiceStatus: '1352',
  decreased: '1354',
  hasMultiInvoice: '1384',
  guildId: '1575',
  guildName: '1575',
  useId: '2230',
};
const ActionTypes = {
  CANCEL: 'cancel',
  CLOSE: 'close',
  SHARE_PAYMENT_LINK: 'sharePaymentLink',
  PAYMENT_OUT_OF_PLATFORM: 'paymentOtOfPlatform',
  SEND_SMS: 'sendSms',
  REDUCE: 'reduce',
};

export { columns, columnsId, ActionTypes };
